<template>
  <badge :type="getBadgeType()">
    {{ statusesOptions[salesInvoice.status] }}
  </badge>
</template>

<script>
import {
  invoiceStatusesOption,
  INVOICE_STATUS_DRAFT,
  INVOICE_STATUS_SENT,
  INVOICE_STATUS_CANCELED,
  INVOICE_STATUS_DELIVERED,
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_PENDING,
  INVOICE_STATUS_PARTIALLY_PAID,
} from "@/constants/invoices";

export default {
  name: "sales-invoice-status-badge",

  components: {},

  mixins: [],

  props: ["salesInvoice"],

  data() {
    return {
      statusesOptions: invoiceStatusesOption,
    };
  },

  computed: {},

  methods: {
    getBadgeType() {
      switch (this.salesInvoice.status) {
        case INVOICE_STATUS_DRAFT:
          return "primary";
        case INVOICE_STATUS_SENT:
          return "default";
        case INVOICE_STATUS_CANCELED:
          return "danger";
        case INVOICE_STATUS_DELIVERED:
          return "success";
        case INVOICE_STATUS_PAID:
          return "success";
        case INVOICE_STATUS_PENDING:
          return "warning";
        case INVOICE_STATUS_PARTIALLY_PAID:
          return "info";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
